<template>
  <div>
    <MateriaSupplierDeliveryOrder v-if="isWuMaoAccount" />
    <ChengKuangSupplierDeliveryOrder v-else />
  </div>
</template>

<script>
  import ChengKuangSupplierDeliveryOrder from './supplierDeliveryOrder.vue';
  import MateriaSupplierDeliveryOrder from './materialTrade/supplierDeliveryOrder.vue';
  export default {
    name: 'supplierDeliveryOrder',
    components: { ChengKuangSupplierDeliveryOrder, MateriaSupplierDeliveryOrder },
  };
</script>

<style lang="scss" scoped></style>
